import { render } from "./ConciergeFee.vue?vue&type=template&id=61f9d010&scoped=true"
import script from "./ConciergeFee.vue?vue&type=script&lang=js"
export * from "./ConciergeFee.vue?vue&type=script&lang=js"

import "./ConciergeFee.vue?vue&type=style&index=0&id=61f9d010&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f9d010"]])

export default __exports__